import { PerspectiveCamera, Vector3, Object3D, MathUtils } from 'three';

const OFFSET_BACK = 30;   // 機体後方 30m
const OFFSET_UP   = 10;   // 機体上方 10m
const LERP_POS    = 0.08; // 位置補間係数（小さいほど追従が遅い）
const LERP_LOOK   = 0.12; // 注視点補間係数

export class FollowCamera {
  readonly camera: PerspectiveCamera;
  private targetPos = new Vector3();
  private currentPos = new Vector3();
  private lookAt = new Vector3();

  constructor(aspect: number) {
    this.camera = new PerspectiveCamera(75, aspect, 1, 30000);
    this.camera.position.set(0, 510, 30);
  }

  update(target: Object3D, delta: number): void {
    // 機体のローカル後方+上方向ベクトルをワールド座標に変換
    const back  = new Vector3(0,  OFFSET_UP,   OFFSET_BACK);
    back.applyQuaternion(target.quaternion);
    this.targetPos.copy(target.position).add(back);

    // 地面に潜らないよう制限
    this.targetPos.y = Math.max(this.targetPos.y, 5);

    // スムーズ追従
    const alpha = MathUtils.clamp(LERP_POS * 60 * delta, 0, 1);
    this.currentPos.lerp(this.targetPos, alpha);
    this.camera.position.copy(this.currentPos);

    // 少し前方（機体より前）を注視
    const lookTarget = new Vector3(0, 0, -80);
    lookTarget.applyQuaternion(target.quaternion);
    lookTarget.add(target.position);

    const alphaL = MathUtils.clamp(LERP_LOOK * 60 * delta, 0, 1);
    this.lookAt.lerp(lookTarget, alphaL);
    this.camera.lookAt(this.lookAt);
  }

  onResize(aspect: number): void {
    this.camera.aspect = aspect;
    this.camera.updateProjectionMatrix();
  }
}
